import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation, Trans } from 'react-i18next';
import { Carousel } from 'react-responsive-carousel';
import SEO from '../../components/seo';
import PageHeader from '../../components/pageHeader';
import NIcon from '../../assets/img/icon/n-icon.svg';
import Style from './style.module.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const Career = () => {
  const { t } = useTranslation();

  const nGamingLifeParagraphs = t('careerPage.nGamingLife.paragraphs', { returnObjects: true });
  const nGamingCareerParagraphs = t('careerPage.nGamingCareer.paragraphs', { returnObjects: true });

  return (
    <>
      <SEO pageKey="career" />
      <PageHeader title={t('careerTitle')} />
      <section className={clsx(Style.section, Style.nGamingLifeSection)}>
        <div className={Style.container}>
          <div className={Style.textWrapper}>
            <h2 className={Style.heading}>{t('careerPage.nGamingLife.title')}</h2>
            <p className={Style.subTitle}>{t('careerPage.nGamingLife.subTitle')}</p>
            <div className={Style.nGamingLife}>
              {Object.values(nGamingLifeParagraphs).map((text, index) => (
                <p key={index}>
                  <img src={NIcon} alt="nGaming-icon" />
                  {t(text)}
                </p>
              ))}
            </div>
          </div>
          <div className={Style.imageWrapper}>
            <Carousel
              interval={1500}
              infiniteLoop
              autoPlay
              showArrows={false}
              showThumbs={false}
              showIndicators={false}
              showStatus={false}
              stopOnHover={false}
              className={Style.slider}
            >
              <div>
                <img src={'./assets/img/slider/01.jpg'} />
              </div>
              <div>
                <img src={'./assets/img/slider/02.jpg'} />
              </div>
              <div>
                <img src={'./assets/img/slider/03.jpg'} />
              </div>
              <div>
                <img src={'./assets/img/slider/04.jpg'} />
              </div>
              <div>
                <img src={'./assets/img/slider/05.jpg'} />
              </div>
              <div>
                <img src={'./assets/img/slider/06.jpg'} />
              </div>
              <div>
                <img src={'./assets/img/slider/07.jpg'} />
              </div>
              <div>
                <img src={'./assets/img/slider/08.jpg'} />
              </div>
            </Carousel>
            <div className={Style.awards}>
              <img src={'./assets/img/best-employee.jpg'} alt="best-employee" />
              <img src={'./assets/img/great-place-to-work.jpg'} alt="great-place-work" />
            </div>
          </div>
        </div>
      </section>

      <section className={clsx(Style.section, Style.nGamingCareerSection)}>
        <div className={Style.container}>
          <div className={Style.textWrapper}>
            <h2 className={Style.heading}>{t('careerPage.nGamingCareer.title')}</h2>
            <p className={Style.subTitle}>{t('careerPage.nGamingCareer.subTitle')}</p>
            <div className={Style.nGamingCareer}>
              {Object.values(nGamingCareerParagraphs).map((text, index) => (
                <p key={index}>{t(text)}</p>
              ))}
            </div>
            <div className={Style.openPositions}>
              <h4 className={Style.openPositionsTitle}>
                {t('careerPage.nGamingCareer.openPositionsTitle')}
              </h4>
              <div className={Style.careerSites}>
                <a
                  href="https://www.linkedin.com/company/ngaming/jobs/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={Style.linkedin}
                    src={'./assets/img/logo/linkedin.png'}
                    alt="nGaming-linkedin"
                  />
                </a>
                <a
                  href="https://www.kariyer.net/firma-profil/ngaming-193681-212023"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={Style.kariyer}
                    src={'./assets/img/logo/kariyer.png'}
                    alt="nGaming-kariyer"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className={Style.imageWrapper}>
            <img src={'./assets/img/home-ngaming-life.png'} alt="ngaming-life" />
          </div>
        </div>
      </section>

      <section className={clsx(Style.section, Style.generalApplicationSection)}>
        <div className={Style.container}>
          <div className={Style.generalApplication}>
            <h2 className={Style.title}>{t('careerPage.generalApplication.title')}</h2>
            <p
              className={Style.description}
              dangerouslySetInnerHTML={{ __html: t('careerPage.generalApplication.description') }}
            />
          </div>
        </div>
      </section>

      <section className={clsx(Style.section, Style.gdprSection)}>
        <div className={Style.container}>
          <div className={Style.gdprWrapper}>
            <h2 className={Style.title}>{t('careerPage.gdpr.title')}</h2>
            <p className={Style.description}>
              <Trans
                className={Style.description}
                i18nKey="careerPage.gdpr.description"
                components={[
                  <Link key={1} to={t('routes.gdpr')}>
                    {1}
                  </Link>,
                ]}
              />
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Career;
